<template>
<div class="chapter">
<div class="inner_page">
<h2 class="sec_front1">List of Maps</h2>
<p class="centerb3"><em class="italic">Maps by Hal Jespersen</em></p>
<p class="center">Battle of Trenton Driving Tour</p>
<p class="centert">Downtown Trenton Driving Tour</p>
<p class="centert">Battle of Princeton Driving Tour</p>
<p class="centert">March on Trenton</p>
<p class="centert">Battle of Trenton</p>
<p class="centert">Battle of Assunpink Creek</p>
<p class="centert">March to Princeton</p>
<p class="centert">The Battle of Princeton</p>
<div class="img_container">
<img alt="Image" src="images/f00vi-01.jpg"/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_Maps.vue?ee6a2e22